"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageStatusEventCard = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var GetFullName_1 = __importDefault(require("@CommonFrontendBackend/Utils/GetFullName"));
var PageStatusEventCard = function (_a) {
    var eventData = _a.eventData;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { align: "start", gap: "s" },
        react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "5" }, getHeading(eventData)),
        renderUserDetails(eventData)));
};
exports.PageStatusEventCard = PageStatusEventCard;
function getHeading(_a) {
    var status = _a.status, subStatus = _a.subStatus, changeSource = _a.changeSource;
    if (changeSource === Types_1.PageStateChangeSource.PageCreation) {
        return "Page created";
    }
    switch (status) {
        case Types_1.ProjectStatus.Live:
            return "Page set to live";
        case Types_1.ProjectStatus.Draft:
            return "Page set to draft";
        case Types_1.ProjectStatus.Accepted: {
            if (subStatus === Types_1.ProjectSubStatus.AcceptedManual) {
                return "Page set to accepted";
            }
            else {
                return "Page accepted";
            }
        }
        case Types_1.ProjectStatus.Declined: {
            if (subStatus === Types_1.ProjectSubStatus.DeclinedExpired) {
                return "Page expired";
            }
            else {
                return "Page set to declined";
            }
        }
        case Types_1.ProjectStatus.Disabled:
            return "Page disabled";
    }
}
function renderUserDetails(_a) {
    var user = _a.user, changeSource = _a.changeSource;
    if (user == null) {
        return react_1.default.createElement(kaleidoscope_1.Text, null, "\u2014");
    }
    return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", gap: "xs" },
        react_1.default.createElement(kaleidoscope_1.Avatar, { firstName: user.firstName, lastName: user.lastName }),
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xxs", align: "start" },
            react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", lineHeight: "compact" }, (0, GetFullName_1.default)(user)),
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xxs" },
                react_1.default.createElement(icons_1.Mail, { size: icons_1.IconSize.Small, color: "default" }),
                react_1.default.createElement(kaleidoscope_1.Text, { secondary: true, size: "xs", lineHeight: "compact" }, user.email)))));
}
